import { render, staticRenderFns } from "./BrandTwo.vue?vue&type=template&id=909115ca"
import script from "./BrandTwo.vue?vue&type=script&lang=js"
export * from "./BrandTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports